module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "device-detail"
  }, [_c('device-map-pivot', {
    attrs: {
      "device": _vm.deviceMap,
      "deviceId": _vm.device
    }
  }), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "centered": "",
      "color": "transparent",
      "light": "",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "#0099E1"
    }
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.name,
      attrs: {
        "href": '#tab-' + tab.name,
        "id": tab.name
      }
    }, [_vm._v("\n      " + _vm._s(tab.name) + "\n    ")])
  }), _vm._v(" "), _c('v-tabs-items', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab-item', {
      key: tab.name,
      attrs: {
        "value": 'tab-' + tab.name
      }
    }, [_c(tab.component, {
      ref: "childComponent",
      refInFor: true,
      tag: "component",
      attrs: {
        "id": _vm.id,
        "device": _vm.device
      }
    })], 1)
  }), 1)], 2), _vm._v(" "), (_vm.device.Organization.id != this.$ponceConfig.organizationDemoId) ? _c('device-actions', {
    attrs: {
      "device": _vm.device,
      "deviceId": _vm.id
    },
    on: {
      "reload-device": _vm.updateDevice
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9727f700","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/Item/DeviceDetail.vue
// module id = 780
// module chunks = 1